import Button, { ButtonVariant } from 'components/common/Button/Button';

type SSOLoginAsProps = {
  xsrfToken: string | undefined;
  userEmail: string;
};

function SSOLoginAs({ xsrfToken, userEmail }: SSOLoginAsProps): JSX.Element {
  return (
    <>
      <form method="POST" action="/acs">
        <input type="hidden" name="xsrf" value={xsrfToken} />
        <input type="hidden" name="pageOrigin" value="react" />
        <div className="AuthPage__Form">
          <h4 className="AuthPage__LoginAsTitle">
            <strong>{userEmail}</strong>
          </h4>
          <Button
            className="AuthPage__LoginAsButton"
            variant={ButtonVariant.PRIMARY}
            type="submit"
            style={{ justifyContent: 'center' }}
          >
            Continue
          </Button>
        </div>
      </form>
    </>
  );
}

export default SSOLoginAs;
